import React from "react";
import { Routes, Route } from "react-router-dom";
import HubPage from "./pages/HubPage";
import GamePage from "./pages/GamePage";
import LeaderboardPage from "./pages/LeaderboardPage";
import RankedMatchPage from "./pages/RankedMatchPage";
import AdminPage from "./pages/AdminPage";
import ChooseUsernameModal from "./components/ChooseUsernameModal";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HubPage />} />
        <Route path="/standard" element={<GamePage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/ranked/:matchId" element={<RankedMatchPage />} />
      </Routes>
      <ChooseUsernameModal />
    </>
  );
}
